import ReportPanel from './ReportPanel';

export default ReportPanel;
